module.exports = __webpack_public_path__ + "img/6_h_no.59b7d9dc.svg";